import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";

@Injectable({
	providedIn: 'root'
})
export class AuthService {
	constructor(
		protected http: HttpClient
	) {}

	loginAs(identification: string | number, reason: string) {
		this.http.get('/login/impersonate', {
			params: {
				username: identification as any,
				reason: reason
			},
			responseType: 'text'
		})
		.subscribe(
			() => window.location.href = '/'
		);
	}
}